/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentSummaryItem {
    getFixupPrototypeFunction() { return ComplianceAssessmentSummaryItem.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentSummaryItem>): ComplianceAssessmentSummaryItem {
        let obj = Object.assign(new ComplianceAssessmentSummaryItem(), model);
        ComplianceAssessmentSummaryItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentSummaryItem>): ComplianceAssessmentSummaryItem {
        if (!model) return null;
        return ComplianceAssessmentSummaryItem.newInstance(<ComplianceAssessmentSummaryItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentSummaryItem) {
        if (!obj) return;

        models.ComplianceAssessmentSummaryItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentSummaryItem): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentSummaryItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary) {
            models.GroupWiseCount.fixupPrototype(this.summary);
        }
    }

    /**
     * Assessment summary group by value
     */
    group_value: string;

    /**
     * Summary status counts
     */
    summary: models.GroupWiseCount;

}
